<!-- eslint-disable vue-a11y/click-events-have-key-events -->
<template>
	<ul
		v-if="visible"
		class="c-Breadcrumbs">
		<li
			v-for="(item, index) in items"
			:key="index"
			class="c-Breadcrumbs__item"
			:class="breadcrumbsItemClassObj(item)">
			<div v-if="items.length <= 3 ||
				(items.length > 3 &&
					(index === 0 || index === (items.length - 2) || index === (items.length - 1)))">
				<i v-if="index > 0"></i>
				<p
					@click="triggerMenu(item)">
					{{ item.label }}<span v-if="item.id">{{ item.id }}</span>
				</p>
			</div>
			<div v-else-if="items.length > 3 && index === 1">
				<i v-if="index > 0"></i>
				<button type="button" @click="toggleMenu(true)">…</button>
				<Menu
					class="c-Breadcrumbs__menu"
					:items="parseMenuItems"
					:active="menuVisible"
					@menuClick="triggerMenu"
					@menuClose="toggleMenu(false)"></Menu>
			</div>
		</li>
		<li v-if="items.length > 3">
		</li>
	</ul>
</template>

<script>
import Menu from '../Menu/Menu.vue'

export default {
	name: 'Breadcrumbs',
	components: {
		Menu
	},
	props: {
		/**
     * Array of items for the Breadcrumbs (follows a defined structure)
     */
		items: {
			type: Array,
			required: true,
			default: () => []
		},
		/**
     * If the Breadcrumbs are visible or not
     * @values true, false
     */
		visible: {
			type: Boolean,
			required: false,
			default: () => true
		}
	},
	data () {
		return {
			menuVisible: false
		}
	},
	computed: {
		parseMenuItems () {
			if (this.items.length > 3) {
				return this.items.slice(1, this.items.length - 2)
			}

			return null
		}
	},
	methods: {
		breadcrumbsItemClassObj (item) {
			return {
				active: item.isActive,
				disabled: item.disabled
			}
		},
		toggleMenu (arg) {
			this.menuVisible = arg
		},
		triggerMenu (item) {
			/**
       * Triggers when a Breadcrumb item is clicked
       * @event click
       * @property {obj} item the item's Object
       */
			if (!item.disabled) {
				this.$emit('click', item)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-Breadcrumbs {
  margin: 0;
  padding: 0 0 calc(#{$base-padding} * 3) 0;
  list-style: none;
  display: flex;
  align-items: center;

  &__item {
    &.active p {
      font-weight: 600;
      color: $un-blue;
    }

    &.disabled p {
      cursor: default;
      text-decoration: none !important;
    }

    div {
      display: flex;
      align-items: center;
      position: relative;
    }

    i {
      margin: 0 calc(#{$base-margin} / 2);
      width: 17px;
      height: 16px;
      display: block;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16'%3E%3Cpath fill='%23343941' fill-rule='evenodd' d='M11.238 7.996a.91.91 0 01-.267.633l-3.2 3.167a.584.584 0 01-.833 0 .583.583 0 010-.834l2.9-2.9c.033-.033.033-.1 0-.133l-2.9-2.9a.582.582 0 010-.833.582.582 0 01.833 0l3.167 3.166c.2.167.3.4.3.634z'/%3E%3C/svg%3E");
    }

    p {
      font-family: $primary-font;
      font-size: 14px;
      line-height: 1.5;
      letter-spacing: 0.25px;
      color: $un-n700;

      span {
        padding-left: calc(#{$base-padding} / 2);
      }
		}

		&:not(.active) p:hover {
			cursor: pointer;
			text-decoration: underline;
		}

    button {
      background-color: transparent;
      border: none;
      outline: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__menu {
    position: absolute !important;
    bottom: -8px;
    left: 24px;
    z-index: 100;
    transform: translateY(100%);
  }
}
</style>
